var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.images && _vm.images.length
    ? _c(
        "span",
        { staticClass: "ScannerImagesButton" },
        [
          _vm.images.length === 1
            ? _c("b-tooltip", { attrs: { label: "צפה בסריקת הדוח" } }, [
                _c(
                  "a",
                  {
                    staticClass: "ScannerImagesButton__Icon",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.open(_vm.images[0])
                      }
                    }
                  },
                  [_c("b-icon", { attrs: { icon: "image" } })],
                  1
                )
              ])
            : _c(
                "b-dropdown",
                {
                  attrs: { position: "is-bottom-right", "aria-role": "list" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "trigger",
                        fn: function() {
                          return [
                            _c(
                              "b-tooltip",
                              { attrs: { label: "צפה בסריקות הדוח" } },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "ScannerImagesButton__Icon",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                      }
                                    }
                                  },
                                  [
                                    _c("b-icon", { attrs: { icon: "image" } }),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "ScannerImagesButton__Count"
                                      },
                                      [_vm._v(_vm._s(_vm.images.length))]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    54980655
                  )
                },
                _vm._l(_vm.images, function(image, index) {
                  return _c(
                    "b-dropdown-item",
                    {
                      key: image.Id,
                      staticClass: "ScannerImagesDrop",
                      attrs: { "aria-role": "listitem" },
                      on: {
                        click: function($event) {
                          return _vm.open(image)
                        }
                      }
                    },
                    [
                      _vm._v(
                        " סריקה " +
                          _vm._s(index + 1) +
                          " · " +
                          _vm._s(_vm.formatDate(image.CreateDate)) +
                          " "
                      )
                    ]
                  )
                }),
                1
              )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }